export default class DPAcfAdjust {
	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT DPAcfAdjust');

		$(document).on(
			'tap',
			'.acf-icon',
			(event) => {
				$(event.target).trigger('click');
			},
		);
		$(document).on(
			'mousedown',
			'.acf-field-relationship .values-list .acf-rel-item .acf-icon[data-name="remove_item"]',
			(event) => {
				console.log('mouseDown');
				$(event.target).trigger('click');
			},
		);
	}
}
